<script setup lang="ts">
import { SelectValue } from 'reka-ui'
import type { SelectValueProps } from 'reka-ui'

defineOptions({
    compatConfig: {
        MODE: 3,
    },
})

const props = defineProps<SelectValueProps>()
</script>

<template>
    <SelectValue
        data-slot="select-value"
        class="select-value"
        v-bind="props"
    >
        <slot></slot>
    </SelectValue>
</template>
